import openDatabase from "../../IndexedDB/openDatabase";

const readFieldAccessFromIndexedDB = async (
  keys,
  dbName = "ERP_DB",
  storeName = "Field_Access",
  dbVersion = 1
) => {
  try {
    // Open the database and object store
    const db = await openDatabase(dbName, storeName, dbVersion);

    // Ensure the store exists
    if (!db.objectStoreNames.contains(storeName)) {
      throw new Error(`Object store '${storeName}' does not exist in the database`);
    }

    // Start a readonly transaction
    const transaction = db.transaction(storeName, "readonly");
    const store = transaction.objectStore(storeName);

    // Create an array of promises for fetching data for each key
    const fetchPromises = keys.map((key) => {
      return new Promise((resolve) => {
        const request = store.get(key);
        request.onsuccess = () => resolve({ key, value: request.result });
        request.onerror = () => resolve({ key, value: undefined }); // Resolve with undefined if error
      });
    });

    // Wait for all fetch operations to complete
    const results = await Promise.all(fetchPromises);

    // Separate found and not found keys
    const foundedFieldConfigs = {};
    const notFoundedEntityNames = [];

    results.forEach(({ key, value }) => {
      if (value !== undefined) {
        foundedFieldConfigs[key.replace("_", "")] = value;
      } else {
        notFoundedEntityNames.push(key);
      }
    });

    return { foundedFieldConfigs, notFoundedEntityNames };
  } catch (error) {
    console.error("Error reading client data:", error);
    return { foundedFieldConfigs: {}, notFoundedEntityNames: keys }; // Return all keys as not found in case of an error
  }
};

export default readFieldAccessFromIndexedDB;
